module.exports = __webpack_public_path__ + "img/ico-love.e61811a3.png";